import { VisitNodePassage } from "../../types";
import { convertToEsgIndexOrNumber } from "common/esg-helpers";
export const addRepRiskRatingHistoryTooltipDataVisitor = (field) => (args) => {
    if (!args || args?.context?.visitNodePassage !== VisitNodePassage.Leaf || !args.visitable || !args.visitable.measures?.[field]) {
        return;
    }
    const repRiskRatingHistory = args.visitable.measures[field];
    if (typeof repRiskRatingHistory !== "string") {
        return;
    }
    args.visitable.measures[field] = {
        tooltipValue: repRiskRatingHistory,
        value: convertToEsgIndexOrNumber(repRiskRatingHistory)
    };
};
